import { useState, useEffect, useCallback } from 'react';
import { axiosInstance } from '@/App';

/**
 * Hook to fetch FM's assigned gyms from the backend.
 * Returns { gyms, loading, error, refetch }
 */
export function useFMGyms() {
  const [gyms, setGyms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchGyms = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await axiosInstance.get('/fm/gyms');
      setGyms(response.data.gyms || response.data || []);
    } catch (err) {
      console.error('Failed to fetch FM gyms:', err);
      setError(err.response?.data?.detail || err.message || 'Failed to load gyms');
      setGyms([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGyms();
  }, [fetchGyms]);

  return { gyms, loading, error, refetch: fetchGyms };
}
